import { ReactNode } from 'react';

import style from '../noteEdit.module.scss';

type ActionsProps = {
  children: ReactNode;
};

export const Actions = ({ children }: ActionsProps) => {
  return <div className={style.saveOrDiscard}>{children}</div>;
};

type ActionsLeftProps = {
  children: ReactNode;
};

export const ActionsLeft = ({ children }: ActionsLeftProps) => {
  return <div className={style.btnWrap}>{children}</div>;
};

type ActionsRightProps = {
  children: ReactNode;
};

export const ActionsRight = ({ children }: ActionsRightProps) => {
  return <div className={style.autosavedBoxWrap}>{children}</div>;
};

// Attach sub-components
Actions.Left = ActionsLeft;
Actions.Right = ActionsRight;
